/**
 * Saneamento do código de acesso digitado ou COLADO.
 *
 * Vive num módulo próprio, e não dentro do componente, por uma razão do
 * playbook: quando o runner não consegue exercitar o formato, a saída não é
 * escrever o teste mesmo assim — é extrair a lógica para um módulo que ele
 * colete. Aqui a regra fica testável sem DOM, sem render e sem simular teclado.
 */

/** Quantidade de dígitos do código. Espelha `OTP_DIGITOS` da API. */
export const CODIGO_DIGITOS = 6;

/**
 * Deixa só dígitos e corta no tamanho.
 *
 * Colar de um e-mail traz espaço, quebra de linha e às vezes o texto em volta
 * ("Seu codigo de acesso e 123456."). Sem isto, colar do e-mail — que é o
 * caminho mais natural — produz um código inválido, e a pessoa conclui que o
 * código não funciona.
 *
 * Corta no fim em vez de recusar: um paste com o texto inteiro ainda contém o
 * código, e recusar seria transformar um caso que dá para resolver num erro.
 */
export function normalizarCodigoColado(bruto: string): string {
  return bruto.replace(/\D/g, '').slice(0, CODIGO_DIGITOS);
}

/** O código está completo o bastante para enviar? */
export function codigoCompleto(valor: string): boolean {
  return normalizarCodigoColado(valor).length === CODIGO_DIGITOS;
}
